<template>
    <div class="wrapper">
        <section class="section">
            <div class="container">

                <ul v-if="breadcrumbs" class="breadcrumbs pb-4">
                    <li v-for="(b, key) in breadcrumbs" :key="b.id" class="text-capitalize">
                        <router-link v-bind:to="b.url">{{ b.title }}</router-link>
                    </li>
                </ul>

                <h2 v-if="search_value" class="search-value">{{ search_value }}</h2>

                <p v-if="search_value && search_directory == null && loading_images == false" class="mb-5">We found <b>{{search_results}}</b> images that matched your search.</p>
                <p v-if="search_value && search_directory && loading_images == false" class="mb-5">We found <b>{{search_results}}</b> images that matched your search in the folder <b>{{ search_directory }}</b>.</p>

                <img v-if="loading_folders || loading_images" class="page-loading" src="@/assets/img/page-loading.gif" />

                <div v-if="loading_folders === false && loading_images === false">
                    <div v-if="folders != false && search == false" class="row" v-bind:class="{'pb-3': folders != false && images != false && search == false}">
                        <div v-for="f in folders" :key="f.id" class="col-sm-4 col-12 mb-3 folder-column">
                            <router-link class="folder-item" v-bind:to="f.url" v-lazy:background-image="f.thumbnail">
                                <div class="folder-title d-flex justify-content-between align-items-center">
                                    <span>{{ f.name }}</span>
                                    <span v-if="is_logged_in" class="small text-uppercase">{{ f.type }}</span>
                                </div>
                                <div class="folder-overlay"></div>
                            </router-link>
                            <div v-if="is_admin && f.root" v-on:click="user_rights_toggl(f.id)" v-bind:class="{'active':(f.id === user_rights_toggl_id)}" class="user-rights">
                                <span v-b-tooltip.hover v-bind:title="[f.type === 'public' ? 'Public' : 'Protected']" v-bind:id="f.id" v-bind:class="[f.type === 'protected' ? 'type-protected' : 'public type-public']" class="user-rights-open-button" for="menu-open"></span>
                                <span v-b-tooltip.hover v-on:click="update_folder_type(f.id, 'protected')" v-bind:class="{'font-weight-bold':(f.type === 'protected')}" title="Protected" class="user-rights-item type-protected"></span>
                                <span v-b-tooltip.hover v-on:click="update_folder_type(f.id, 'public')" v-bind:class="{'font-weight-bold':(f.type === 'public')}" title="Public" class="user-rights-item type-public"></span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div v-if="images != false">
                        <div class="row" v-bind:class="{'pt-5 border-top': folders != false && images != false && search == false}">
                            <div v-if="loading_images === false" v-for="(i, key) in images" :key="i.id" class="col-6 col-sm-4 col-md-3 image-column mb-5">
                                <div
                                    class="image-container mb-2"
                                    v-lazy:background-image="i.s3_url"
                                    v-on:click="image_modal"
                                    v-bind:data-id="i.id"
                                    v-bind:data-title="i.name"
                                    v-bind:data-extension="i.extension"
                                    v-bind:data-size="i.size"
                                    v-bind:data-width="i.width"
                                    v-bind:data-height="i.height"
                                    v-bind:data-creation-date="i.created_at"
                                    v-bind:data-src="i.s3_url"
                                    v-bind:data-description="i.description"
                                    v-bind:data-is-thumbnail="i.is_thumbnail"
                                >
                                </div>
                                <div class="d-flex flex-column align-items-center">
                                    <div class="image-title mb-2">
                                        {{ i.name }}
                                    </div>
                                    <div class="image-format mb-2">
                                        {{ i.extension }}
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <button v-on:click="download_image" type="button" class="btn btn-download d-flex align-items-center" v-bind:data-id="i.id"><svg class="download-icon" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.41421" viewBox="0 0 495 461" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(.967314 0 0 .970128 10.1426 -14.8808)"><path d="m-10.485 15.339h511.07v474.561h-511.07z" fill="none"/><g fill-rule="nonzero"><path d="m468.3 255.8.2-.2c.3-.4.6-.7.8-1.1.1-.1.1-.2.2-.3.2-.4.5-.8.7-1.2 0-.1.1-.2.1-.2.2-.4.4-.8.6-1.3 0-.1 0-.1.1-.2.2-.4.3-.9.5-1.4 0-.1 0-.2.1-.2.1-.5.3-.9.3-1.4 0-.2 0-.3.1-.5.1-.4.1-.8.2-1.2.1-.6.1-1.1.1-1.7s0-1.1-.1-1.7c0-.4-.1-.8-.2-1.2 0-.2 0-.3-.1-.5-.1-.5-.2-.9-.3-1.4 0-.1 0-.2-.1-.2-.1-.5-.3-.9-.5-1.4 0-.1 0-.1-.1-.2-.2-.4-.4-.9-.6-1.3 0-.1-.1-.2-.1-.2-.2-.4-.4-.8-.7-1.2-.1-.1-.1-.2-.2-.3-.3-.4-.5-.8-.8-1.1-.1-.1-.1-.1-.2-.2-.4-.4-.7-.9-1.2-1.3l-98.9-98.8c-6.7-6.7-17.6-6.7-24.3 0s-6.7 17.6 0 24.3l69.6 69.6h-276.7c-9.5 0-17.2 7.7-17.2 17.1 0 9.5 7.7 17.2 17.2 17.2h276.8l-69.1 69.1c-6.7 6.7-6.7 17.6 0 24.3 3.3 3.3 7.7 5 12.1 5s8.8-1.7 12.1-5l98.3-98.3c.5-.6.9-1 1.3-1.4z" transform="matrix(0 1.03079 1.03379 0 -8.17709 -105.014)"/><path d="m110.7 34.3h128c9.5 0 17.2-7.7 17.2-17.1 0-9.5-7.7-17.2-17.2-17.2h-128c-51.3 0-93.1 41.8-93.1 93.1v303.7c0 51.3 41.8 93.1 93.1 93.1h125.9c9.5 0 17.2-7.7 17.2-17.1 0-9.5-7.7-17.2-17.2-17.2h-125.9c-32.4 0-58.8-26.4-58.8-58.8v-303.7c.1-32.5 26.4-58.8 58.8-58.8z" transform="matrix(0 -1.03079 1.03379 0 -8.17709 505.112)"/></g></g></svg>Download</button>
                                        <div class="download-mark d-flex">
                                            <input class="hidden checkbox-mark" v-bind:id="`cbx-${key}`" type="checkbox" v-bind:checked="cart_ids.indexOf(i.id.toString()) >= 0" disabled />
                                            <label class="cbx" v-on:click="add_to_cart" v-bind:for="`cbx-${key}`" v-bind:data-id="i.id" v-bind:data-name="i.name"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <infinite-loading v-if="images.length >= 60" @infinite="loadMoreItems" distance="300">
                            <div slot="spinner"><img class="infinity-loading" src="/static/img/loading-lazy.gif" /></div>
                            <div slot="no-more" class="d-none"></div>
                            <div slot="no-results" class="d-none"></div>
                        </infinite-loading>
                    </div>
                    <div v-if="loading_folders === false && loading_images === false && folders == false && images == false" class="folder-empty">
                        <p class="m-5">Folder is empty.</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- Modal -->
        <b-modal id="image-modal" modal-class="image-modal" size="xl" centered hide-header hide-footer>
            <img v-if="modal.play_video === false" class="modal-image" v-bind:src="modal.image_src" />
            <video v-if="modal.play_video" class="modal-video" controls autoplay>
                <source v-bind:src="modal.play_video_src" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <div class="image-description p-5">
                <button type="button" class="close" v-on:click="$bvModal.hide('image-modal')">
                    <svg class="rotate-close" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.41421" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m110.621 138.966h268.857v241.893h-268.857z" fill="#fff"/><path d="m256 48c-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208-93.1-208-208-208zm52.7 283.3-52.7-52.7-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-52.7 52.7 52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z" fill-rule="nonzero" transform="matrix(1.20826 0 0 1.20826 -53.315 -53.315)"/></svg>
                </button>
                <div v-if="is_admin && modal.image_description_edit == false" class="image-thumbnail-admin">
                    <small v-if="modal.image_is_thumbnail == 0" v-on:click="update_image_is_thumbnail(modal.image_id, 1)" class="d-block">
                        Use as thumbnail<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 105c-101.8 0-188.4 62.4-224 151 35.6 88.6 122.2 151 224 151s188.4-62.4 224-151c-35.6-88.6-122.2-151-224-151zm0 251.7c-56 0-101.8-45.3-101.8-100.7S200 155.3 256 155.3 357.8 200.6 357.8 256 312 356.7 256 356.7zm0-161.1c-33.6 0-61.1 27.2-61.1 60.4s27.5 60.4 61.1 60.4 61.1-27.2 61.1-60.4-27.5-60.4-61.1-60.4z"/></svg>
                    </small>
                    <small v-if="modal.image_is_thumbnail == 1" v-on:click="update_image_is_thumbnail(modal.image_id, 0)" class="d-block">
                        Remove as thumbnail<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256.1 144.8c56.2 0 101.9 45.3 101.9 101.1 0 13.1-2.6 25.5-7.3 37l59.5 59c30.8-25.5 55-58.4 69.9-96-35.3-88.7-122.3-151.6-224.2-151.6-28.5 0-55.8 5.1-81.1 14.1l44 43.7c11.6-4.6 24.1-7.3 37.3-7.3zM52.4 89.7l46.5 46.1 9.4 9.3c-33.9 26-60.4 60.8-76.3 100.8 35.2 88.7 122.2 151.6 224.1 151.6 31.6 0 61.7-6.1 89.2-17l8.6 8.5 59.7 59 25.9-25.7L78.2 64 52.4 89.7zM165 201.4l31.6 31.3c-1 4.2-1.6 8.7-1.6 13.1 0 33.5 27.3 60.6 61.1 60.6 4.5 0 9-.6 13.2-1.6l31.6 31.3c-13.6 6.7-28.7 10.7-44.8 10.7-56.2 0-101.9-45.3-101.9-101.1 0-15.8 4.1-30.7 10.8-44.3zm87.8-15.7l64.2 63.7.4-3.2c0-33.5-27.3-60.6-61.1-60.6l-3.5.1z"/></svg>
                    </small>
                </div>
                <div class="image-description-block">
                    <h5>Name</h5>
                    <p class="image-description-title">{{ modal.image_title }}</p>
                    <h5>Description</h5>
                    <div class="image-description-item">
                        <span class="description-title">
                            File format
                        </span>
                        <span class="description-value text-uppercase">
                            {{ modal.image_extension }}
                        </span>
                    </div>
                    <div class="image-description-item">
                        <span class="description-title">
                            Size
                        </span>
                        <span class="description-value">
                            {{ modal.image_size }}
                        </span>
                    </div>
                    <div
                        v-if="modal.image_extension == 'jpg' || modal.image_extension == 'jpeg' || modal.image_extension == 'png' || modal.image_extension == 'gif'"
                        class="image-description-item"
                    >
                        <span class="description-title">
                            Proportions
                        </span>
                        <span class="description-value">
                            {{ modal.image_width }}x{{ modal.image_height }} pixels
                        </span>
                    </div>
                    <div class="image-description-item">
                        <span class="description-title">
                            Creation Date
                        </span>
                        <span class="description-value">
                            {{ modal.image_creation_date }}
                        </span>
                    </div>
                </div>
                <div v-if="is_admin == true || modal.image_description != ''" class="image-custom-description-block mt-2">
                    <div v-if="modal.image_description && modal.image_description_edit == false" class="image-custom-description">
                        <small class="d-block mb-2"><b>Description</b></small>
                        <small class="description-text d-block">{{ modal.image_description }}</small>
                    </div>
                    <div v-if="is_admin" class="description-admin mt-1">
                        <div class="form-group description-edit">
                            <textarea v-if="modal.image_description_edit" v-model="modal.image_description" class="form-control" placeholder="Enter description..."></textarea>
                        </div>
                        <small v-if="modal.image_description_edit" v-on:click="update_image_description(modal.image_id)" class="d-block">Save description</small>
                        <small v-if="modal.image_description == '' && modal.image_description_edit == false" v-on:click="modal.image_description_edit = true">Add description</small>
                        <small v-if="modal.image_description && modal.image_description_edit == false" v-on:click="modal.image_description_edit = true">Edit description</small>
                    </div>
                </div>
                <div class="d-flex flex-row mt-4">
                    <button v-if="(modal.image_extension == 'mp4' || modal.image_extension == 'mov') && modal.play_video === false" v-on:click="play_video" type="button" class="btn btn-primary mr-1" v-bind:class="{load: modal.play_video_loading}" v-bind:data-id="modal.image_id">
                        Play Video
                        <div class="loading"></div>
                    </button>
                    <button v-on:click="download_image" type="button" class="btn btn-primary" v-bind:data-id="modal.image_id">Download</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios';
    const CancelToken = axios.CancelToken;
    let cancel;

    /* eslint-disable */
    export default {
        data () {
            return {
                breadcrumbs: null,
                route: '',
                folders: false,
                images: false,
                loading_folders: false,
                loading_images: false,
                search: false,
                search_value: null,
                search_directory: null,
                search_results: null,
                page: 1,
                user_rights_toggl_id: null,
                modal: {
                    image_id: null,
                    image_title: null,
                    image_extension: null,
                    image_size: null,
                    image_width: null,
                    image_height: null,
                    image_creation_date: null,
                    image_src: null,
                    image_description: null,
                    image_description_edit: false,
                    image_is_thumbnail: false,
                    play_video: false,
                    play_video_src: null,
                    play_video_loading: false
                }
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hidden', (bv_event, modal_id) => {
                if (modal_id == 'image-modal') {
                    this.modal.play_video = false;
                    this.modal.play_video_src = null;
                    this.modal.play_video_loading = false;
                }
            })
        },
        computed: {
            is_logged_in () {
                return this.$store.state.isLoggedIn;
            },
            is_admin () {
                return this.$store.state.is_admin;
            },
            cart_ids () {
                return this.$store.getters.cart_ids;
            }
        },
        created () {
            this.preLoadItems();
        },
        watch: {
            $route (to, from) {
                this.preLoadItems();
                fbq('track', 'ViewContent');
            }
        },
        methods: {
            preLoadItems() {
                if (cancel != undefined) {
                    cancel();
                }
                this.loadItems();
            },
            /*
            |--------------------------------------------------------------------------
            | Load items
            |--------------------------------------------------------------------------
            |
            | Load items (folders and files) from API. Handling both search and
            | regular path navigation.
            |
            */
            loadItems () {
                /*
                |--------------------------------------------------------------------------
                | Show loading when fetching images from API
                |--------------------------------------------------------------------------
                */
                this.folders = false;
                this.images = false;
                this.loading_folders = true;
                this.loading_images = true;
                this.page = 1;

                const breadcrumbs_home = {'id': 0, 'title': 'Digital Assets', 'url': '/'};

                /*
                |--------------------------------------------------------------------------
                | Check if search or regular path navigation by looking for the query
                | (?=)search in the URL.
                |--------------------------------------------------------------------------
                */
                if (this.$route.query.search) {
                    /*
                    |--------------------------------------------------------------------------
                    | Set search variable to true
                    |--------------------------------------------------------------------------
                    */
                    this.search = true;

                    /*
                    |--------------------------------------------------------------------------
                    | Reset directory variable
                    |--------------------------------------------------------------------------
                    */
                    this.breadcrumbs = null;

                    /*
                    |--------------------------------------------------------------------------
                    | Set search value variable from query value
                    |--------------------------------------------------------------------------
                    */
                    const search_value = encodeURIComponent(this.$route.query.search);
                    this.search_value = this.$route.query.search;

                    /*
                    |--------------------------------------------------------------------------
                    | Check if search contains a specific directory or is global
                    |--------------------------------------------------------------------------
                    */
                    // const search_directory = (this.$route.path === '/') ? this.$route.path : this.$route.path.substr(1);
                    // this.search_directory = (this.$route.path === '/') ? null : decodeURIComponent(this.$route.path.substr(1));

                    /*
                    |--------------------------------------------------------------------------
                    | Fetch search results from API and hide loading
                    |--------------------------------------------------------------------------
                    */
                    // axios.get(process.env.VUE_APP_API_URL + '/api/search?value=' + search_value + '&directory=' + search_directory, {
                    axios.get(process.env.VUE_APP_API_URL + '/api/search?value=' + search_value, {
                        cancelToken: new CancelToken(function executor(c) {
                            cancel = c;
                        })}).then(response => (
                            this.search_results = response.data.hits,
                            this.images = response.data.results,
                            this.loading_folders = false,
                            this.loading_images = false
                        )).catch(function(thrown) {
                            if (axios.isCancel(thrown)) {
                                console.log('Request canceled');
                            }
                        })
                }
                else {
                    /*
                    |--------------------------------------------------------------------------
                    | Set search variable to false
                    |--------------------------------------------------------------------------
                    */
                    this.search = false;

                    /*
                    |--------------------------------------------------------------------------
                    | Reset search value and search directory variables
                    |--------------------------------------------------------------------------
                    */
                    this.search_value = null;
                    this.search_directory = null;

                    /*
                    |--------------------------------------------------------------------------
                    | Check if path is root or subdirectory, set route and breadcrumbs variables
                    | depending on the result.
                    |--------------------------------------------------------------------------
                    */
                    if (this.$route.fullPath != '/') {
                        /*
                        |--------------------------------------------------------------------------
                        | Set route variable
                        |--------------------------------------------------------------------------
                        */
                        this.route = window.location.pathname;

                        /*
                        |--------------------------------------------------------------------------
                        | Set breadcrumbs and route path array
                        |--------------------------------------------------------------------------
                        */
                        const breadcrumbs_array = new Array(breadcrumbs_home);
                        const route_path_array = this.$route.path.split('%2F');

                        /*
                        |--------------------------------------------------------------------------
                        | Loop through the route path array and create breadcrumbs
                        |--------------------------------------------------------------------------
                        */
                        route_path_array.forEach(function (value, index) {
                            if (index > 0) {
                                const breadcrumb_title = decodeURIComponent(value);
                                const breadcrumb_url = route_path_array.slice(0, index + 1).join('%2F');

                                breadcrumbs_array.push({
                                    'id': index,
                                    'title': breadcrumb_title,
                                    'url': breadcrumb_url
                                });
                            }
                        });

                        /*
                        |--------------------------------------------------------------------------
                        | Set breadcrumbs variable
                        |--------------------------------------------------------------------------
                        */
                        this.breadcrumbs = breadcrumbs_array;
                    }
                    else {
                        this.route = '';
                        this.breadcrumbs = new Array(breadcrumbs_home);
                    }

                    /*
                    |--------------------------------------------------------------------------
                    | Fetch folders and images depending on the directory from API
                    |--------------------------------------------------------------------------
                    */
                    axios.get(process.env.VUE_APP_API_URL + '/api/folders' + this.route, {
                        cancelToken: new CancelToken(function executor(c) {
                            cancel = c;
                        })}).then(response => (
                            this.folders = response.data,
                            this.loading_folders = false
                        )).catch(function(thrown) {
                            if (axios.isCancel(thrown)) {
                                console.log('Request canceled');
                            }
                        })
                    axios.get(process.env.VUE_APP_API_URL + '/api/images' + this.route, {
                        cancelToken: new CancelToken(function executor(c) {
                            cancel = c;
                        })}).then(response => (
                            this.images = response.data,
                            this.loading_images = false
                        )).catch(function(thrown) {
                            if (axios.isCancel(thrown)) {
                                console.log('Request canceled');
                            }
                        })
                    }
            },
            loadMoreItems($state) {
                this.page += 1;

                if (this.$route.query.search) {
                    const search_value = encodeURIComponent(this.$route.query.search);
                    const search_directory = (this.$route.path === '/') ? this.$route.path : this.$route.path.substr(1);

                    axios.get(process.env.VUE_APP_API_URL + '/api/search?value=' + search_value + '&directory=' + search_directory + '&page=' + this.page)
                    .then(({ data }) => {
                        if (data.results.length) {
                            this.images = this.images.concat(data.results);
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    });
                } else {
                    axios.get(process.env.VUE_APP_API_URL + '/api/images' + this.route + '?page=' + this.page)
                    .then(({ data }) => {
                        if (data.length) {
                            this.images = this.images.concat(data);
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    });
                }
            },
            /*
            |--------------------------------------------------------------------------
            | Image modal
            |--------------------------------------------------------------------------
            |
            | Bootstrap modal showing image data (title, extension, size, width, height
            | and creation date) when clicking on image.
            |
            */
            image_modal: function (event) {
                /*
                |--------------------------------------------------------------------------
                | Set image description edit to false
                |--------------------------------------------------------------------------
                */
                this.modal.image_description_edit = false;

                /*
                |--------------------------------------------------------------------------
                | Get image data from data attributes from current image
                |--------------------------------------------------------------------------
                */
                this.modal.image_id = event.currentTarget.getAttribute('data-id').toString();
                this.modal.image_title = event.currentTarget.getAttribute('data-title').toString();
                this.modal.image_extension = event.currentTarget.getAttribute('data-extension').toString();
                this.modal.image_size = parseInt(event.currentTarget.getAttribute('data-size'));
                this.modal.image_width = event.currentTarget.getAttribute('data-width').toString();
                this.modal.image_height = event.currentTarget.getAttribute('data-height').toString();
                this.modal.image_creation_date = event.currentTarget.getAttribute('data-creation-date').toString();
                this.modal.image_description = event.currentTarget.getAttribute('data-description').toString();
                this.modal.image_is_thumbnail = event.currentTarget.getAttribute('data-is-thumbnail').toString();

                /*
                |--------------------------------------------------------------------------
                | Calculate image size to human readable from bytes
                |--------------------------------------------------------------------------
                */
                if (this.modal.image_size) {
                    this.modal.image_size = this.formatBytes(this.modal.image_size);
                }

                /*
                |--------------------------------------------------------------------------
                | Formatting creation date to year, month and day
                |--------------------------------------------------------------------------
                */
                if (this.modal.image_creation_date) {
                    this.modal.image_creation_date = this.modal.image_creation_date.split(' ')[0];
                }

                /*
                |--------------------------------------------------------------------------
                | Populate image modal with current image data and show modal
                |--------------------------------------------------------------------------
                */
                this.modal.image_src = event.currentTarget.getAttribute('data-src').toString();
                this.$bvModal.show('image-modal');
            },
            play_video: function (event) {
                this.modal.play_video_loading = true;
                var id = event.currentTarget.getAttribute('data-id');

                axios.get(process.env.VUE_APP_API_URL + '/api/download/' + id)
                    .then(response => (
                        this.modal.play_video_loading = false,
                        this.modal.play_video = true,
                        this.modal.play_video_src = response.data[0]['dropbox_url']
                    ))
            },
            /*
            |--------------------------------------------------------------------------
            | Download image
            |--------------------------------------------------------------------------
            |
            | Single image download that gets temporarly link from API and trigger
            | file download.
            |
            */
            download_image: function (event) {
                /*
                |--------------------------------------------------------------------------
                | Show loading when fetching image from API
                |--------------------------------------------------------------------------
                */
                this.$store.commit('downloading', true);

                /*
                |--------------------------------------------------------------------------
                | Get current image ID from data attribute
                |--------------------------------------------------------------------------
                */
                var id = event.currentTarget.getAttribute('data-id');

                /*
                |--------------------------------------------------------------------------
                | Fetch image temporary link from API and trigger file download
                |--------------------------------------------------------------------------
                */
                axios.get(process.env.VUE_APP_API_URL + '/api/download/' + id)
                    .then(response => (
                        this.js_file_download(response.data[0]['name'], response.data[0]['dropbox_url']),
                        this.$store.commit('downloading', false),
                        this.$ga.event('image', 'download', response.data[0]['name'], 1)
                    ))
            },
            /*
            |--------------------------------------------------------------------------
            | Add to cart
            |--------------------------------------------------------------------------
            |
            | Add images to cart when clicking on image checkbox. Doing that by
            | creating cookie where we save image ID and name. Download of cart
            | items are handled in Header.vue.
            |
            */
            add_to_cart: function (event) {
                /*
                |--------------------------------------------------------------------------
                | Get current image ID and name from data attributes
                |--------------------------------------------------------------------------
                */
                var id = event.currentTarget.getAttribute('data-id');
                var name = event.currentTarget.getAttribute('data-name');

                /*
                |--------------------------------------------------------------------------
                | Check if cart cookie already exists
                |--------------------------------------------------------------------------
                */
                if (this.$cookies.get('cart')) {
                    /*
                    |--------------------------------------------------------------------------
                    | Get current cart items
                    |--------------------------------------------------------------------------
                    */
                    var exist = false;
                    var items = this.$cookies.get('cart').items;

                    /*
                    |--------------------------------------------------------------------------
                    | Looping through cart and remove unchecked item
                    |--------------------------------------------------------------------------
                    */
                    for (var i = 0; i < items.length; i++) {
                        if(items[i].id == id) {
                            items.splice(i, 1);
                            exist = true;
                        }
                    }

                    /*
                    |--------------------------------------------------------------------------
                    | Adding new item to cart
                    |--------------------------------------------------------------------------
                    */
                    if (!exist) {
                        var item = {
                            id: id,
                            name: name
                        };

                        items.push(item);
                    }
                }
                /*
                |--------------------------------------------------------------------------
                | If cart cookie doesn't exist we just add the current item to cart
                |--------------------------------------------------------------------------
                */
                else {
                    var item = {
                        id: id,
                        name: name
                    };

                    var items = [item];
                }

                /*
                |--------------------------------------------------------------------------
                | Creating or updating cart cookie depending on items
                |--------------------------------------------------------------------------
                */
                var cart = {items: items};
                this.$cookies.set('cart', cart);

                /*
                |--------------------------------------------------------------------------
                | Commit load cart so cart updates for the user without reload
                |--------------------------------------------------------------------------
                */
                this.$store.commit('load_cart');
            },
            update_image_is_thumbnail: function (id, status) {
                this.modal.image_is_thumbnail = status;

                axios.put(process.env.VUE_APP_API_URL + '/api/images/' + id, {
                    is_thumbnail: status
                })
                .then(() => (
                    this.preLoadItems()
                ));
            },
            update_image_description: function (id) {
                this.modal.image_description_edit = false;

                const image_description = this.modal.image_description ? this.modal.image_description.trim() : ''
                this.modal.image_description = image_description

                axios.put(process.env.VUE_APP_API_URL + '/api/images/' + id, {
                    description: image_description
                })
                .then(() => (
                    this.preLoadItems()
                ));
            },
            user_rights_toggl: function (folder_id) {
                if (this.is_admin) {
                    if (this.user_rights_toggl_id == folder_id) {
                        this.$root.$emit('bv::enable::tooltip', folder_id.toString());
                        this.user_rights_toggl_id = null;
                    }
                    else {
                        this.$root.$emit('bv::enable::tooltip');
                        this.$root.$emit('bv::hide::tooltip', folder_id.toString());
                        this.$root.$emit('bv::disable::tooltip', folder_id.toString());
                        this.user_rights_toggl_id = folder_id;
                    }
                }
            },
            update_folder_type: function (folder_id, folder_type) {
                axios.put(process.env.VUE_APP_API_URL + '/api/folder/type', {
                    folder_id: folder_id,
                    folder_type: folder_type
                })
                .then(() => (
                    this.preLoadItems()
                ));
            },
            /*
            |--------------------------------------------------------------------------
            | JS file download
            |--------------------------------------------------------------------------
            */
            js_file_download(name, file_url) {
                var tempLink = document.createElement('a');
                tempLink.style.display = 'none';
                tempLink.href = file_url;
                tempLink.setAttribute('download', name);

                var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                // Safari thinks _blank anchor are pop ups. We only want to set _blank
                // target if the browser does not support the HTML5 download attribute.
                // This allows you to download files in desktop safari if pop up blocking
                // is enabled.
                if (typeof tempLink.download === 'undefined' || iOS === true) {
                    tempLink.setAttribute('target', '_blank');
                }

                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
            },
            /*
            |--------------------------------------------------------------------------
            | Format bytes
            |--------------------------------------------------------------------------
            */
            formatBytes (bytes, decimals) {
                if (bytes == 0) return '0 Bytes';
                var k = 1024,
                dm = decimals <= 0 ? 0 : decimals || 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            }
        }
    }
</script>
